export default __webpack_public_path__ + "static/media/816.1ca902b6.png";